import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BottomNav = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();
  
  const navItems = [
    {
      id: 'home',
      icon: 'home',
      label: 'Hjem',
      path: '/',
    },
    {
      id: 'search',
      icon: 'search',
      label: 'Søk',
      path: '/sok',
    },
    {
      id: 'create',
      icon: 'add_circle',
      label: 'Opprett',
      path: '/opprett-annonse',
      isCenter: true,
    },
    {
      id: 'messages',
      icon: 'chat_bubble',
      label: 'Meldinger',
      path: '/meldinger',
    },
    {
      id: 'profile',
      icon: 'person',
      label: 'Profil',
      path: isAuthenticated ? `/profil/${user?.id}` : '/logg-inn',
    },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    if (path === '/sok') {
      return location.pathname === '/sok';
    }
    return location.pathname.startsWith(path.split('?')[0]);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 pb-safe">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              item.isCenter ? 'relative' : ''
            }`}
          >
            {item.isCenter ? (
              // Sentral opprett-knapp med spesiell styling
              <div className="absolute -top-5 bg-gradient-to-br from-[#1E3A5F] to-[#0A1929] rounded-full p-3 shadow-lg shadow-[#0A1929]/30">
                <span className="material-symbols-outlined text-white text-2xl">
                  {item.icon}
                </span>
              </div>
            ) : (
              <>
                <span
                  className={`material-symbols-outlined text-2xl transition-colors ${
                    isActive(item.path)
                      ? 'text-[#0A1929]'
                      : 'text-slate-400'
                  }`}
                  style={{
                    fontVariationSettings: isActive(item.path)
                      ? "'FILL' 1, 'wght' 500"
                      : "'FILL' 0, 'wght' 400",
                  }}
                >
                  {item.icon}
                </span>
                <span
                  className={`text-[10px] mt-0.5 font-medium transition-colors ${
                    isActive(item.path)
                      ? 'text-[#0A1929]'
                      : 'text-slate-400'
                  }`}
                >
                  {item.label}
                </span>
              </>
            )}
          </Link>
        ))}
      </div>
      
      {/* Aktiv indikator-linje */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-transparent">
        {navItems.map((item, index) => (
          !item.isCenter && isActive(item.path) && (
            <div
              key={item.id}
              className="absolute top-0 h-full bg-[#0A1929] transition-all duration-300"
              style={{
                left: `${(index / navItems.length) * 100}%`,
                width: `${100 / navItems.length}%`,
              }}
            />
          )
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
